import difference from 'lodash.difference';
import { useCallback, useEffect, useState } from 'react';
import { ANALYTICS_EVENTS } from '../../common/constants';
import useAnalytics from './useAnalytics';

export default function useStationImpressions(stationIDs) {
  const [loggedStationIds, setLoggedStationIds] = useState([]);
  const analytics = useAnalytics();

  useEffect(() => {
    // Record station impressions if new stations provided
    const newStationIDs = difference(stationIDs, loggedStationIds);
    if (newStationIDs.length) {
      const attributes = {
        UISource: 'Web',
        Context: 'Station Search Page',
        0: JSON.stringify({
          Date: (new Date()).toISOString(),
          Entries: newStationIDs.map(id => ({
            Position: stationIDs.indexOf(id).toString(),
            PriceHist_ID: '-1',
            Station_ID: id.toString(),
          })),
        }),
      };

      // Fill properties 1-44 with an empty string because that's what mobile does
      let index = 45;
      while (index) {
        attributes[index] = '';
        index -= 1;
      }

      analytics.tagEvent({
        name: ANALYTICS_EVENTS.STATION_IMPRESSION,
        attributes,
      });
      setLoggedStationIds(stationIDs);
    }
  }, [analytics, loggedStationIds, stationIDs]);

  const clearStationIds = useCallback(() => {
    setLoggedStationIds([]);
  }, []);

  return [clearStationIds];
}
